import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TutorialsInfo from './TutorialsInfo';
import { getLocalizedName } from '../../helpers';
import AppContext from '../../AppContext';

let containerStyle = {
    margin: '10px 0px'
};
let imageStyle = {
    width: '100%',
    height: 'auto',
};
let textStyle = {
    margin: '10px 0px',
    color: '#fff',
    padding: '20px',
    textAlign: 'center',
};
let slideContainerStyle = {
    height: '100px',
};
let leftActionsContainerStyle = {
    display: 'inline-block',
    width: '50%',
};
let rightActionsContainerStyle = {
    display: 'inline-block',
    width: '50%',
    textAlign: 'right',
};


class Tutorial extends Component {
    constructor(props) {
        super(props);

        this.state = {
            slide: 0,
        };
    }

    handlePreviousSlide = () => {
        if ((this.state.slide - 1) >= 0) {
            this.setState({ slide: this.state.slide - 1 });
        }
    }

    handleNextSlide = () => {
        let tutorial = TutorialsInfo[this.props.tutorialId];
        let slidesLength = tutorial.slides.length;
        if ((this.state.slide + 1) < slidesLength) {
            this.setState({ slide: this.state.slide + 1 });
        } else {
            this.props.closeTutorial();
        }
    }

    render() {
        let appContext = new AppContext();
        let currentLanguage = appContext.getLanguage();
        let tutorial = TutorialsInfo[this.props.tutorialId];
        let slides = tutorial.slides;
        let slidesLength = slides.length;
        let currSlide = slides[this.state.slide];

        let maxWidth = this.props.fullScreen === true ? '100%' : '65vw';

        return (
            <div style={containerStyle}>
                <div style={{ maxWidth }}>
                    <img src={currSlide.image} style={imageStyle} alt={`tutorialId-${this.props.tutorialId}-slide-${this.state.slide}`} />
                    <br />
                    <div style={slideContainerStyle}>
                        <div style={{ ...textStyle, backgroundColor: tutorial.color }} dangerouslySetInnerHTML={{ __html: getLocalizedName(currentLanguage, currSlide.texts) }} />
                    </div>
                </div>
                <div>
                    <div style={leftActionsContainerStyle}>
                        <Button onClick={this.handlePreviousSlide} color="primary" disabled={(this.state.slide - 1) < 0}>
                            {'Previous'}
                        </Button>
                    </div>
                    <div style={rightActionsContainerStyle}>
                        <Button onClick={this.handleNextSlide} color="primary">
                            {(this.state.slide + 1) >= slidesLength ?
                                'Finish'
                                :
                                'Next'
                            }
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
Tutorial.propTypes = {
    tutorialId: PropTypes.number.isRequired,
    fullScreen: PropTypes.bool.isRequired,
    closeTutorial: PropTypes.func.isRequired,
};

export default Tutorial;